import axios from "axios";
import { useAuthStore } from "../store/authStore";
import { useModalStore } from "../store/modalStore";

// Create an Axios instance
const axiosInstance = axios.create({
  // For local use
  baseURL:
    process.env.REACT_APP_ENV === "dev" ? "http://localhost:5000" : undefined,
});

// Axios interceptor to add access token to request headers
axiosInstance.interceptors.request.use(
  (config) => {
    const { accessToken } = useAuthStore.getState();
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Axios response interceptor to handle unauthorized responses
axiosInstance.interceptors.response.use(
  (response) => {
    // If the response is successful, just return it
    return response;
  },
  (error) => {
    if (
      error.response.statusText === "Unauthorized" &&
      error.response.status === 401
    ) {
      // If 401 Unauthorized, open the modal
      useModalStore.getState().setModalOpen(true); /// Using a store to manage modal state

      // Optionally, you could log out the user or redirect here:
      useAuthStore.getState().logout();

      // Return a rejected promise so the component can handle the error properly
      return Promise.reject(error);
    }

    // If the error is not a 401, just reject the promise normally
    return Promise.reject(error);
  }
);

export default axiosInstance;
